export default class details {
  constructor(address_data, company_data, payment_cards, soldtos) {
    this.address_data = address_data;
    this.company_data = company_data;
    this.payment_cards = payment_cards;
    this.soldto_list = soldtos;
  }
}
